import React from 'react';
import {
  Dialog,
  Grid,
  Typography,
  TextField,
  InputAdornment,
  Box,
  Tooltip,
  Paper,
} from '@mui/material';

import { useTheme } from '@emotion/react';

import { useState, useEffect, useRef } from 'react';
import { Pendingwarning } from 'component/BuyersMarketplace/MakeOffers';
import { poppins400, poppins500, poppins700 } from 'theme/common.style';
import {
  Button,
  useMediaQuery,
  CircularProgress,
  IconButton,
} from '@mui/material';

const CounterOfferalreadyexists = ({
  open,
  onClose,
  onContinue,
  pendingUserId,
  address,
  manageOfferData,
  onContinues,
  onCloses,
  tableData,
  pendingOfferType,
  fromTableHead = false, // Add this prop
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm')); // detects screen width < 600px
  const matchessm = useMediaQuery(theme.breakpoints.down('sm'));
  const matches500 = useMediaQuery(theme.breakpoints.down(500));
  const matches400 = useMediaQuery(theme.breakpoints.down(600));
  const matches750 = useMediaQuery(theme.breakpoints.down(750));
  const matches700 = useMediaQuery(theme.breakpoints.down(700));
  const matches800 = useMediaQuery(theme.breakpoints.down(850));
  const matches900 = useMediaQuery(theme.breakpoints.down(900));
  const matchesmd = useMediaQuery(theme.breakpoints.down('md'));

  const getTitleText = () => {
    if (!pendingOfferType) return '';

    // Normalize to array
    const types = Array.isArray(pendingOfferType)
      ? pendingOfferType
      : [pendingOfferType];

    // Normalize & dedupe
    const normalized = new Set(
      types.map((type) => type.replace(' Pending', '').trim().toLowerCase())
    );

    const hasCounter = normalized.has('counter');
    const hasPrivate = normalized.has('private');

    if (hasCounter && hasPrivate) {
      return 'Counter and Private offer already exists';
    }

    if (hasCounter) {
      return 'Counter offer already exists';
    }

    if (hasPrivate) {
      return 'Private offer already exists';
    }

    return '';
  };

  const getDescriptionText = () => {
    if (!pendingOfferType) return '';

    // Normalize to array
    const types = Array.isArray(pendingOfferType)
      ? pendingOfferType
      : [pendingOfferType];

    // Normalize & dedupe
    const normalized = new Set(
      types.map((type) => type.replace(' Pending', '').trim().toLowerCase())
    );

    const hasCounter = normalized.has('counter');
    const hasPrivate = normalized.has('private');

    // Use "selected buyer" for common checkbox (fromTableHead = true), "this buyer" for individual checkbox
    const buyerText = fromTableHead ? 'selected buyer' : 'this buyer';

    if (hasCounter && hasPrivate) {
      return (
        `A pending counter and private offer already exists for ${buyerText}.\n` +
        'Sending a new counter and private offer will automatically withdraw the existing ones ' +
        'to ensure only one active offer remains.'
      );
    }

    if (hasCounter) {
      return (
        `A pending counter offer already exists for ${buyerText}.\n` +
        'Sending a new counter offer will automatically withdraw the existing one ' +
        'to ensure only one active offer remains.'
      );
    }

    if (hasPrivate) {
      return (
        `A pending private offer already exists for ${buyerText}.\n` +
        'Sending a new private offer will automatically withdraw the existing one ' +
        'to ensure only one active offer remains.'
      );
    }

    return '';
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          borderRadius: '5px',
          minWidth: matchessm ? '95%' : '400px',
          boxShadow: ' -4px, 4px rgba(0, 0, 0, 0.09)',
          padding: matchessm ? '30px 20px' : '30px',
        },
      }}
    >
      <Grid container height={'100%'}>
        <Grid item xs={12}>
          <Typography
            sx={{
              ...poppins400,
              fontSize: matchessm ? '10px' : '14px',
              color: '#666666',
            }}
          >
            {address || manageOfferData?.propertyAddress}
          </Typography>
        </Grid>
        <Grid
          item
          xs={12}
          display={'flex'}
          alignItems={'center'}
          padding={'20px 0px'}
        >
          <Pendingwarning />
          <Typography
            sx={{
              ...poppins500,
              fontSize: matchessm ? '16px' : '24px',
              paddingLeft: '12px',
            }}
          >
            {getTitleText()}
          </Typography>
        </Grid>

        <Grid item textAlign={'left'}>
          <Typography
            sx={{
              ...poppins400,
              fontSize: matchesmd ? '12px' : '16px',
              color: '#666666',
              whiteSpace: 'pre-line',
            }}
          >
            {getDescriptionText()}
          </Typography>
        </Grid>

        <Grid
          item
          container
          direction="row"
          justifyContent={'flex-end'}
          gap={2}
          marginTop={matchessm ? 2 : 4}
        >
          <Grid item>
            <Button
              variant="outlined"
              style={{
                padding: matchessm ? '6px 23px' : '10px 39px',
                width: '100%',
                height: matchessm ? '35px' : '41px',
                fontSize: matchessm ? '12px' : '14px',
                color: '#666666',
                fontWeight: '400',
                fontFamily: 'Poppins',
                border: '1px solid rgba(17, 35, 71, 0.1)',
                borderRadius: '5px',
                textTransform: 'capitalize',
              }}
              onClick={onClose || onCloses}
            >
              Cancel
            </Button>
          </Grid>
          <Grid
            item
            sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}
          >
            <Button
              variant="outlined"
              style={{
                padding: matchessm ? '6px 23px' : '10px 39px',
                width: '100%',
                height: matchessm ? '35px' : '41px',
                fontSize: matchessm ? '12px' : '14px',
                color: '#FFFFFF',
                fontWeight: '400',
                fontFamily: 'Poppins',
                background: '#4CA4D6',
                borderRadius: '5px',
                textTransform: 'capitalize',
              }}
              onClick={onContinue || onClose}
            >
              Continue
            </Button>
          </Grid>
        </Grid>
      </Grid>
    </Dialog>
  );
};

export default CounterOfferalreadyexists;
